var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInput(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 160,
    viewBox: "0 0 320 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 152,
    transform: "translate(8 8)",
    fill: "#A5B0B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 57C80 52.5817 83.5817 49 88 49H232C236.418 49 240 52.5817 240 57V95C240 99.4183 236.418 103 232 103H88C83.5817 103 80 99.4183 80 95V57Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232 53H88C85.7909 53 84 54.7909 84 57V95C84 97.2091 85.7909 99 88 99H232C234.209 99 236 97.2091 236 95V57C236 54.7909 234.209 53 232 53ZM88 49C83.5817 49 80 52.5817 80 57V95C80 99.4183 83.5817 103 88 103H232C236.418 103 240 99.4183 240 95V57C240 52.5817 236.418 49 232 49H88Z",
    fill: "#4C6170"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 39,
    width: 74,
    height: 8,
    transform: "rotate(90 114 39)",
    fill: "#4C6170"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 117,
    width: 12,
    height: 8,
    transform: "rotate(-180 108 117)",
    fill: "#4C6170"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 117,
    width: 12,
    height: 8,
    transform: "rotate(-180 124 117)",
    fill: "#4C6170"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 43,
    width: 12,
    height: 8,
    transform: "rotate(-180 108 43)",
    fill: "#4C6170"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 43,
    width: 12,
    height: 8,
    transform: "rotate(-180 124 43)",
    fill: "#4C6170"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 151,
    width: 304,
    height: 9,
    fill: "#B4DDEB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInput);
export default __webpack_public_path__ + "static/media/input.dbbcee66bff9093ca4ce7d70dd216a40.svg";
export { ForwardRef as ReactComponent };